import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';
import { SpaceAwareTooltipDirective } from '@celum/ng2base/directives';

@Component({
  selector: 'celum-chip',
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  host: {
    class: 'celum-chip',
    '[class.celum-chip--light]': "color() === 'light'",
    '[class.celum-chip--dark]': "color() === 'dark'",
    '[class.celum-chip--error]': '!!errorTooltip()',
    '[class.celum-chip--disabled]': 'disabled()',
    '[class.celum-chip--without-action]': '!enableClose()'
  },
  imports: [MatTooltipModule, TranslatePipe, CelumIcon, SpaceAwareTooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CelumChipComponent {
  public prefixIcon = input<string>();
  public prefix = input<string>();
  public text = input<string>();
  public color = input<'light' | 'dark'>('dark');
  /** Visually fades the chip's content. Does not affect the remove icon, use {@link enableClose} for that. */
  public disabled = input(false);
  /** Whether the "remove" ({@link closeIcon}) feature is enabled or not. */
  public enableClose = input(true);
  /**
   * Tooltip for the whole chip, shown on everything except the close icon. While set, it replaces the chip's text and
   * error tooltips. To make sure that always just one tooltip is shown.
   */
  public tooltip = input<string>();
  public errorTooltip = input<string>();
  public closeIcon = input<string | IconConfiguration>('cancel-m');
  public closeIconTooltip = input<string>();
  public readonly remove = output<boolean>();

  protected closeIconConfig = computed(() => {
    const icon = this.closeIcon();
    return typeof icon === 'string' ? new IconConfiguration(icon).withIconSize(16) : icon;
  });
  protected prefixIconConfig = computed(() => this.prefixIcon() && new IconConfiguration(this.prefixIcon()).withIconSize(16).withColor('inherit'));
}
